import { Injectable } from '@angular/core';
import { KJUR } from 'jsrsasign';
import CryptoJS from 'crypto-js';

import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CryptoService {
  constructor() {
    window.CryptoJS = CryptoJS;
  }

  cryptHS512(agCode: string, severTime: Date) {
    try {
      var oHeader = { alg: 'HS512', typ: 'JWT' };
      var sHeader = JSON.stringify(oHeader);
      // var tNow = window.KJUR.jws.IntDate.get('now');
      var tEnd = KJUR.jws.IntDate.get('now + 1day');
      //var tNow = parseInt(timeNow);
      //var tEnd = parseInt(timeEnd);

      //var oValue = { 'AgCode': agcode, "exp": tEnd, "nbf": tNow, "iat": tNow, 'RequestDate': severTime };
      var oValue = { AgCode: agCode, exp: tEnd, RequestDate: severTime };
      var sPayload = JSON.stringify(oValue);
      var secretKey = 'VINAJET@' + agCode + `@${environment.apiSecretKey}`;
      var sJWS = KJUR.jws.JWS.sign('HS512', sHeader, sPayload, secretKey);
      return sJWS;
    } catch (ex) {
      console.error('[CryptoService:cryptHS512]', ex);
      return '';
    }
  }

  encrypt(value: string): string {
    try {
      const cipherText = CryptoJS.AES.encrypt(
        JSON.stringify(value),
        environment.secretKey,
      ).toString();
      return cipherText;
    } catch (error) {
      console.error('[CryptoService:encrypt]', error);
      return '';
    }
  }

  decrypt<T>(cipherText: string): T | null {
    try {
      const bytes = CryptoJS.AES.decrypt(cipherText, environment.secretKey);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8)) as T;
      return decryptedData;
    } catch (error) {
      console.error('[CryptoService:decrypt]', error);
      return null;
    }
  }
}
